export const situacaoContrato = {
    PROCESSO_ATA: 1,
    PROCESSO_ENCAMINHADO: 2,
    PRE_CONTRATO_EM_ELABORACAO: 3,
    PARECER_JURIDICO_ENCAMINHADO: 4,
    PARECER_ELABORADO: 5,
    FOLHA_HOMOLOGACAO: 6,
    CONTRATO_CADASTRADO: 7,
    CONTRATO_VIGENTE: 8,
    ENCAMINHADO_PARA_GESTOR: 9,
    INICIADO_ADITIVO_CONTRATO: 10,
    CONTRATO_PARA_COTACAO: 11,
    RESULTADO_PARA_COTACAO: 12,
    PARECER_JURIDICO_PARA_ADITIVO: 13,
    ATA_DIREX_REGISTRADA: 14,
    TERMO_ENCAMINHADO_PARA_ADITIVO: 15,
    TERMO_ADITIVO_ELABORADO: 16,
    INICIADA_ASSINATURA_ADITIVO: 17,
    ADITIVO_VIGENTE: 19,
    ADITIVO_VIGENTE2: 23,
    INICIADA_ASSINATURA_CONTRATO: 22,
    CONTRATO_DISTRIBUIDO: 24,
    PRE_CONTRATO_PARCIAL: 25,
    CONTRATO_FINALIZADO: 27,
    ADITIVO_DISTRIBUIDO: 28,
    ADITIVO_ASSINADO: 29,
    CONTRATO_CANCELADO: 30,
    CONTRATO_ASSINADO: 31,
    PRE_CONTRATO_CONCLUIDO: 32,
    CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO: 33,
    ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO: 34
}
